export const LOGIES_STEPS = [
	'Gegevens van het logies',
	'Gegevens van de aanvrager',
	'Gegevens van de aanvraag',
	'Financiële gegevens',
	'Opladen van bewijsstukken',
	'Ondertekenen',
];
